// extracted by mini-css-extract-plugin
module.exports = {"wrapperAdaptive":"AvatarBar_wrapperAdaptive__dkEqN","inputFile":"AvatarBar_inputFile__1PKJy","customFileInput":"AvatarBar_customFileInput__2Apz3"};